var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 866,
    viewBox: "0 0 63.8 22.1",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45a9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#3faeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbbab"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 22.075)",
    gradientUnits: "userSpaceOnUse",
    x1: 26.253,
    x2: 43.091,
    xlinkHref: "#a",
    y1: 18.725,
    y2: 18.725
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 22.075)",
    gradientUnits: "userSpaceOnUse",
    x1: 20.622,
    x2: 37.459,
    xlinkHref: "#a",
    y1: 12.025,
    y2: 12.025
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63.6 16.4-1.5.2s-.1-.6-.6-1-2.2-.3-2.2.7c0 .9.7.8 2.1 1.1 1.3.3 2.4.7 2.4 2.5 0 1-.7 2.2-2.9 2.2-3.6 0-3.3-2.7-3.3-2.7h1.6s.1.9.7 1.1c.7.3 1.9.2 2.1-.4s.2-1.3-1.7-1.5c-1.9-.3-2.7-1.1-2.7-2.4.1-1.2.8-2.2 3.3-2.2 2.5.1 2.7 2.4 2.7 2.4zm-6.9 0-1.5.2s-.1-.6-.6-1-2.2-.3-2.2.7c0 .9.7.8 2.1 1.1 1.3.3 2.4.7 2.4 2.5 0 1-.7 2.2-2.9 2.2-3.6 0-3.3-2.7-3.3-2.7h1.7s.1.9.7 1.1c.7.3 1.9.2 2.1-.4s.2-1.3-1.7-1.5c-1.7-.2-2.6-.9-2.6-2v-.4c.1-1.2.8-2.2 3.2-2.2 2.3.1 2.6 2.4 2.6 2.4zm-8.5 2.8h1.7v.1c-.1.6-.4 2.7-3.3 2.7-2.6 0-3.5-2-3.5-4.1 0-2.2 1.3-3.8 3.7-3.8 2.7 0 2.9 2.6 2.9 2.6l-1.6.2s-.1-1.4-1.5-1.4-1.9 1.1-1.9 2.4.4 2.8 1.8 2.8 1.7-1.5 1.7-1.5zm-8.5-4.9v7.6h-1.4v-.7s-.5.9-1.7.9c-1.3 0-2.2-.6-2.3-2.9 0-2.4 1.5-3 2.5-3 .9 0 1.5.7 1.5.7v-2.6zm-1.4 4.8c0-.8-.1-1.7-1.3-1.7s-1.2 1.4-1.2 1.8c0 .5.1 1.6 1.2 1.6s1.3-.9 1.3-1.7zm-5.1-1v3.7h-1.5v-3.6c0-.5-.3-.9-.9-.9s-1.2.5-1.2 1v3.5h-1.5v-5.6h1.5v.8s.5-1 2-.9c1.7.2 1.6 1.8 1.6 2zm-7.8-1.8h1.5v5.6h-1.5zm0-2h1.5v1.3h-1.5zm-.6 2-1.6 5.6h-1.5l-1-3.7-1 3.7h-1.4l-1.6-5.6h1.6l.8 3.6 1.1-3.6h1.3l.9 3.7.8-3.7zm-10.3-2.1h1.5v7.6h-1.5zm-2.7 2.1h1.5v5.6h-1.5zm0-2h1.5v1.3h-1.5zm-1.2 4v3.5h-1.4v-.7s-.4.5-1 .7c-.9.3-2.2.1-2.6-.9-.3-.8 0-1.7.8-2.1 1-.5 2.7-.4 2.7-.4s.1-.4-.1-.7c-.1-.3-.4-.4-.8-.4-1 0-1 .7-1 .7l-1.4-.1s0-.7.7-1.2c.4-.3.9-.4 1.8-.4 1.1 0 2.3.4 2.3 2zm-2.3 2.5c1-.2.9-1.4.9-1.4h-.4c-.3 0-.7 0-1 .1-.5.1-.7.3-.8.5-.1.3 0 .6.3.8.2.1.5.1 1 0zm-2.1-6.6v1.5h-2.3v6.2h-1.7v-6.3h-2.2v-1.4z",
    fill: "#252a2f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.1 2.3s-1.4 2.1-3.8 1.7-2.8-4-7.1-4c-5.3 0-5.9 4.5-5.9 4.5s1.5-2.2 3.8-1.8 3.2 4 7.9 4 5.1-4.4 5.1-4.4z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.5 9s-1.4 2.1-3.8 1.7-2.8-4-7.1-4c-5.3 0-5.9 4.5-5.9 4.5s1.5-2.2 3.8-1.8c2.2.4 3.2 4 7.9 4s5.1-4.4 5.1-4.4z",
    fill: "url(#c)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.160d3de3a73a551fed84370fcf32a83f.svg";
export { ForwardRef as ReactComponent };